import Vue from 'vue'
import App from './App.vue'
import {router} from "@/router";
import pinia from "@/plugin/pinia";
import '@iflat/iflat-ui/src/scss/style.scss'
import './scss/global-styles.scss';
import '@/plugin/index'
import '@/directives/index'
import {ENTITIES} from "@/lib/helpConst";
import {ROUTES} from "@/router/routerConst";
import {COMPONENT_TYPES} from "@iflat-ui/constants/components";
import Metric from "@/lib/metric";

Vue.config.productionTip = false
Vue.prototype.$entities = ENTITIES
Vue.prototype.$routes = ROUTES
Vue.prototype.$components = COMPONENT_TYPES
Vue.prototype.$metric = new Metric()

new Vue({
  router,
  pinia,
  render: h => h(App)
}).$mount('#app')
